import createCachedFetch from '~/util/cachedFetch/createCachedFetch'

function encodeQuery(obj) {
  return encodeURIComponent(JSON.stringify(obj))
}

function author(pharosService, $q) {
  const limit = 10
  const authorsServiceCache = createCachedFetch(async (response) => {
    return {
      data: await response.json(),
    }
  })

  const logErrorToSentry = (url) => (error) => {
    pharosService.sendExceptionToSentry(error, `Failed to fetch ${url}`)
    throw error
  }

  function fetchAuthors(search, field) {
    let querySearch
    let queryObj
    let regexSearch = '^' + search

    const opts = { $options: 'i' }

    if (field === 'name') {
      queryObj = {
        $or: [
          {
            firstName: { $regex: search, ...opts },
          },
          {
            lastName: { $regex: search, ...opts },
          },
          {
            byline: { $regex: search, ...opts },
          },
        ],
      }
      querySearch = encodeQuery(queryObj)
    } else if (field === 'email') {
      regexSearch = '^' + search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      queryObj = { email: { $regex: regexSearch, ...opts } }
      querySearch = encodeQuery(queryObj)
    } else {
      querySearch = `{"${field}":"${search}"}`
    }

    const url = `/authorservice-readonly/api/v1/author-service?ans=1&limit=${limit}&q=${querySearch}`
    return authorsServiceCache(url).catch(logErrorToSentry(url))
  }

  const cachedSearches = {}

  function setResults(resolve, search, prefix, response) {
    cachedSearches[prefix + search] = response.data.q_results
    resolve(cachedSearches[prefix + search])
  }

  function setResultsError(reject, ...args) {
    reject(args)
  }

  function cachedUnderLimit(searchTerm) {
    let temp = searchTerm
    const lowered = searchTerm.toLowerCase()
    let parentMatch
    let cachedItems = null
    while (temp.length && !cachedSearches[temp]) {
      temp = temp.slice(0, -1)
    }

    if (temp.length) {
      parentMatch = cachedSearches[temp].slice()

      if (parentMatch && parentMatch.length < limit) {
        cachedItems = parentMatch.filter(function (obj) {
          return (
            (obj.name || '').toLowerCase().indexOf(lowered) > -1 ||
            (obj.additional_properties.original.firstName || '')
              .toLowerCase()
              .indexOf(lowered) > -1 ||
            (obj.additional_properties.original.lastName || '')
              .toLowerCase()
              .indexOf(lowered) > -1
          )
        })
      }
    }

    cachedUnderLimit[searchTerm] = cachedItems
    return cachedItems
  }

  this.searchName = function (searchTerm) {
    const deferred = $q.defer()

    if (cachedSearches[searchTerm]) {
      deferred.resolve(cachedSearches[searchTerm])
    } else {
      const cachedFilter = cachedUnderLimit(searchTerm)
      if (cachedFilter) {
        deferred.resolve(cachedFilter)
      } else {
        fetchAuthors(searchTerm, 'name').then(
          setResults.bind(this, deferred.resolve, searchTerm, ''),
          setResultsError.bind(this, deferred.reject, searchTerm)
        )
      }
    }

    return deferred.promise
  }

  this.searchByEmail = (emailAddress) => {
    const deferred = $q.defer()

    fetchAuthors(emailAddress, 'email', true).then(
      (result) => {
        deferred.resolve(result.data)
      },
      (obj) => {
        deferred.reject(obj)
      }
    )

    return deferred.promise
  }
}

export default ['pharosService', '$q', author]
